import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import RootState from './root_state';

import user from './modules/user';
import attendee from './modules/attendee';
import classrooms from './modules/classrooms';
import enrollments from './modules/enrollments';
import assessments from './modules/assessments';
import courses from './modules/courses';
import contracts from './modules/contracts';
import comments from './modules/comments';
import notifications from './modules/notifications';
import notes from './modules/notes';
import boardsClassrooms from './modules/boardsClassrooms';
import boardsTeachers from './modules/boardsTeachers';
import teachers from './modules/teachers';
import boards from './modules/boards';
import materials from './modules/materials';
import lists from './modules/lists';
import listItems from './modules/listItems';
import listSessions from './modules/listSessions';
import boardSections from './modules/boardSections';
import texts from './modules/texts';
import images from './modules/images';
import videos from './modules/videos';
import contents from './modules/contents';
import articles from './modules/articles';
import questions from './modules/questions';
import lives from './modules/lives';
import appointments from './modules/appointments';
import roles from './modules/roles';
import readings from './modules/readings';
import assertions from './modules/assertions';
import progresses from './modules/progresses';
import replies from './modules/replies';
import solutions from './modules/solutions';
import reactions from './modules/reactions';
import zoomSignature from './modules/zoomSignature';
import boardsGroupsModule from './boardsgroups';
import forumAPIModule from './forumAPI';
import chimeraModule from './chimera';
import alumniProfile from './modules/alumni-profile';
import microcertificates from './modules/microcertificates';
import postgradStudyPlanning from './postgradStudyPlanning';
import exerciseCommentAttachments from './modules/exerciseCommentAttachments';
import currentPeriod from './modules/periods';
import undergradStudyPlan from './modules/undergradStudyPlan';
import postgradMicrocertificate from './postgradMicrocertificate';
import postgradContractExtension from './postgradContractExtension';
import postgradStudentDocuments from './postgradStudentDocuments';
import postgradTrial from './postgradTrial';

Vue.use(Vuex);

export const store: StoreOptions<RootState> = {
  state: {},
  modules: {
    zoomSignature,
    reactions,
    user,
    attendee,
    forumAPIModule,
    comments,
    exerciseCommentAttachments,
    classrooms,
    enrollments,
    assessments,
    courses,
    contracts,
    boardsClassrooms,
    boards,
    materials,
    lists,
    listItems,
    listSessions,
    boardSections,
    texts,
    images,
    videos,
    contents,
    articles,
    questions,
    lives,
    appointments,
    roles,
    readings,
    assertions,
    progresses,
    replies,
    solutions,
    chimeraModule,
    boardsGroupsModule,
    alumniProfile,
    microcertificates,
    boardsTeachers,
    teachers,
    postgradStudyPlanning,
    notifications,
    notes,
    currentPeriod,
    undergradStudyPlan,
    postgradMicrocertificate,
    postgradContractExtension,
    postgradStudentDocuments,
    postgradTrial,
  },
};

export default new Vuex.Store<RootState>(store);
